import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { formatBuildLabel, formatBuildTooltip } from '../utils/appVersion';

const AppVersionLabel = ({ expanded = false, sx = {} }) => (
  <Tooltip title={formatBuildTooltip()} placement="right" arrow>
    <Box
      sx={{
        px: expanded ? 2 : 0,
        py: 0.75,
        textAlign: expanded ? 'left' : 'center',
        color: 'rgba(255,255,255,0.55)',
        userSelect: 'text',
        ...sx,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: expanded ? '0.7rem' : '0.62rem',
          fontFamily: 'monospace',
          letterSpacing: '0.02em',
        }}
      >
        v{formatBuildLabel()}
      </Typography>
    </Box>
  </Tooltip>
);

export default AppVersionLabel;
